import { html, css, LitElement, nothing } from 'lit';
import { repeat } from 'lit-html/directives/repeat.js'

import { WindhagerSchedule } from "./windhager-schedule";
import { localize } from './localize/localize';

export class WindhagerScheduleCard extends LitElement {

	// private properties
	_hass;
	_commandTopic;

	// internal reactive states
	static get properties() {
	    return {
	        _header: { state: true },
	        _entities: { state: true },
	        _names: { state: true },
					_selectedEntity: { state: false},
					_selectedSchedule: { state: false}
	    };
	}
	
	// lifecycle interface
	setConfig(config) {
	    this._header = config.header === "" ? nothing : config.header;
	    this._entities = config.entities;
			if (! this._entities || this._entities.length == 0) {
      	throw new Error(localize('config.missing_entities'));
			}
			this._names = config.names;
			if (! this._names || this._names.length < this._entities.length) {
      	throw new Error(localize('config.missing_names'));
			}
	    this._commandTopic = config.command_topic === "" ? nothing : config.command_topic;
			if (! this._commandTopic) {
      	throw new Error(localize('config.missing_command_topic'));
			}

	    // call set hass() to immediately adjust to a changed entity
	    // while editing the entity in the card editor
	    if (this._hass) {
	        this.hass = this._hass
	    }
	}

	set hass(hass) {
		this._hass = hass;

		
		for (const entity of this._entities) {
			let state = hass.states[entity];
		}

		if (! this._selectedEntity ) {
			if (this._entities.length == 0) {
				this._selectedEntity = nothing;
			} else {
				this._selectedEntity = this._entities[0];
			}
		}

		if (! this._selectedSchedule ) {
			this._selectedSchedule = this.getSchedule(this._selectedEntity);
		}
	}

	render() {
		let content;

		if (this._entities.length == 0) {
			content = html`
				<p class="error">${localize('common.entities_missing')}</p>
			`;
		} else if (! this._hass.states[this._selectedEntity]) {
			content = html`
				<p class="error">${localize('common.entity_unavailable', '{entity}', this._selectedEntity)}</p>
			`;
		} else {
			content = html`
				<ha-select
					label="${localize('common.programme')}"
					class="windhager-programme-select"
					.value="${this._selectedEntity}"
					@selected="${this.programmeChanged}"
				>
					${repeat(this._entities, item => item,
						(item,index) => html`<mwc-list-item .value=${item}>${this._names[index]}</mwc-list-item>`)}
				</ha-select>
				<div>
					<windhager-schedule schedule="${this._selectedSchedule}" .parent="${this}"></windhager-schedule>
				</div>
			`;
		}

		return html`
		    <ha-card header="${this._header}">
		        <div class="card-content">
		            ${content}
		        </div>
		    </ha-card>
		`;
	}

	getSchedule(entity) {
		if (this._entities.includes(entity)) {
			let state = this._hass.states[entity];
			if (!state)
				return "[]"
			let programme = state.state;
			let json = programme.replaceAll("'", "\"");
			return JSON.parse(json);
		}
		return "[]";
	}

	programmeChanged(event) {
		const index = event.detail.index;
		if (index < this._entities.length) {
			let entity = this._entities[index];
			this._selectedEntity = entity;
			this._selectedSchedule = this.getSchedule(entity);
		}
	}

	publish(message) {
		let oid = this._hass.states[this._selectedEntity].attributes["oid"];
		this._hass.callService('mqtt', 'publish', {
			topic: this._commandTopic,
			payload: JSON.stringify({ "OID": oid, "value": message })
		})
	}

	static styles = css`
		.windhager-programme-select {
			width: 100%;
		}
	`;
}
